import cLayout from './cLayout.vue';

export default {
  install(Vue) {
    Vue.component('cLayout', cLayout);
  },
};
